import { useMemo } from 'react';
import '../App.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet-async';
import { getMonitoringDashboardUrl } from '../utils/monitoringDashboardUrl';

function Monitoring() {
  const dashboardUrl = useMemo(() => getMonitoringDashboardUrl(), []);

  return (
    <>
      <Helmet>
        <title>Resident Monitoring Dashboard</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta
          name="description"
          content="Harpwood House resident monitoring dashboard."
        />
        <link rel="canonical" href="https://www.harpwood.house/monitoring" />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section phone-calls-page">
            <div className="phone-calls-container">
              <h1>Resident Monitoring Dashboard</h1>

              <div className="phone-calls-dashboard-panel">
                <div className="phone-calls-iframe-wrap">
                  <iframe
                    title="Harpwood Resident Monitoring Dashboard"
                    src={dashboardUrl}
                    className="phone-calls-iframe"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </section>
        </main>

      <Footer />
      </div>
    </>
  );
}

export default Monitoring;
